import classes from './StartChat.module.sass'
import { Button } from '../button/Button'

import { useStartChat } from './hooks/useStartChat'
import { Group } from '../../types/enums'
import {
  CargoItemInterface,
  SlotItemInterface,
  TransportItemInterface,
} from '../../types/interfaces'

type Props = {
  order: SlotItemInterface | TransportItemInterface | CargoItemInterface
  group: Group
}

export const StartChat = ({ order, group }: Props) => {
  const { startChat } = useStartChat(order, group)
  return (
    <div className={classes.Anchor}>
      <div className={classes.Container}>
        <Button small text="Написать в чат" onClick={startChat} />
      </div>
    </div>
  )
}
